import _defineProperty from "/opt/webapp/node_modules/.pnpm/next@14.2.15_@babel+core@7.29.0_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable import/no-default-export */

var createLogger = function createLogger() {
  if (typeof window === 'undefined' || process.env.NODE_ENV === 'test') {
    var bunyan = require('bunyan');
    // eslint-disable-next-line clubmed/use-alias
    var config = require("../config");
    return bunyan.createLogger(_objectSpread(_objectSpread({
      name: 'b2c',
      level: 'warn',
      serializers: {
        err: bunyan.stdSerializers.err
      }
    }, config.get('logger.server')), process.env.NODE_ENV === 'test' && {
      level: 'fatal'
    }));
  }
  return console;
};
var logger = createLogger();
export default logger;